const {AoflElement, store, pageAreaTrackerMixin} = aofljs;
/**
 * @summary DownloadAppPage  DownloadAppPage
 * @class DownloadAppPage
 * @extends {AoflElement}
 */
class DownloadAppPage extends pageAreaTrackerMixin(AoflElement) {
  /**
   * Creates an instance of DownloadAppPage.
   * @memberof DownloadAppPage
   */
  constructor() {
    super(store);
  }

  /**
   *
   * @readonly
   * @static
   * @memberof DownloadAppPage
   */
  static get properties() {
    return {
      pageInfo: {
        type: Object,
        value: {
          pageLoadUrl: '@downloadApp:pageLoad',
          page_info_key: 'download-app'
        }
      }
    };
  }

  /**
   *
   * @readonly
   * @static
   * @memberof DownloadAppPage
   */
  static get is() {
    return 'download-app-page';
  }
}

window.customElements.define(DownloadAppPage.is, DownloadAppPage);



// WEBPACK FOOTER //
// ./download_app/es-US/js/download-app-page/download-app-page.js